import { Link, Navigate, Outlet, createFileRoute } from '@tanstack/react-router'
import { Button } from '@neutrino/ui'
import { useIsNomineeRole } from '@/hooks/use-org-role'
import { RouteProtection } from '@/components/auth/route-protection'

export const Route = createFileRoute('/_nominee')({
  component: NomineeLayoutRoute,
})

function NomineeLayoutRoute() {
  const isNomineeRole = useIsNomineeRole()

  return (
    <RouteProtection>
      {!isNomineeRole ? (
        <Navigate to='/dashboard' replace />
      ) : (
        <div className='bg-background min-h-svh'>
          <header className='border-border border-b'>
            <div className='mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4'>
              <h1 className='text-base font-semibold'>Nominee Portal</h1>
              <nav>
                <Button asChild variant='ghost'>
                  <Link to='/claims'>Claims</Link>
                </Button>
              </nav>
            </div>
          </header>

          <main className='mx-auto w-full max-w-6xl p-4'>
            <Outlet />
          </main>
        </div>
      )}
    </RouteProtection>
  )
}
